// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DvapZ","left":"styles_left__3FGJB"};